import React, { useEffect, useState } from "react";
import confirmPaymentImage from "../../../assets/images/confirmPayment.svg";
import styles from "./TransationsSuccessMain.module.css";
import { useLocation, useHistory, Link } from "react-router-dom";
import queryString from "query-string";
import { confirmPayment } from "../../../config/confirmPayment";

export default function TransactionsSuccessMain() {
  const { search } = useLocation();
  const { provider, trxref, reference, tx_ref } = queryString.parse(search);
  const [application_id,setApplication_id] = useState("")

  const [loading, setLoading] = useState(true);

  const history = useHistory();

  useEffect(() => {
    function getWithExpiry(key) {
      const itemStr = localStorage.getItem(key);
      if (!itemStr) {
        return null;
      }

      const item = JSON.parse(itemStr);
      const now = new Date();

      if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        console.log("REMOVE");
        return null;
      }

      if (provider !== undefined) {
        const confirmIt = async (token) => {
          const confirm = await confirmPayment(token, provider, search);
          if (confirm.data) {
            console.log(confirm.data);
            setLoading(false);
            setApplication_id(confirm.data.data.application_id)
          } else if (confirm.error) {
            console.log(confirm.error);
            history.push("/dashboard/transactions");
          }
        };
        confirmIt(item.value.token);
      } else {
        history.push("/dashboard/transactions");
      }
    }
    getWithExpiry("userData");

    document.title = "VisaPro | ThankYou";
  }, []);

  return (
    <div className={styles.main}>
      {loading ? (
         <div className="spinner-border" role="status"></div>
      ) : (
        <>
          <img
            src={confirmPaymentImage}
            alt="Payment SuccessFull"
            className={styles.image}
          />
          <h1 className={styles.head}>Payment was successful</h1>
          <Link to={`/dashboard/my-applications/application-center/${application_id}`}>
          <button className={styles.btn}>Start application</button>
          </Link>
        </>
      )}
    </div>
  );
}
